import { useTranslation } from "react-i18next";
import * as React from "react";
import {
  Button,
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@guardian/shared-ui";
import { Check, ChevronDown } from "lucide-react";
import { LOCALE_OPTIONS as languages } from "@/locales/registry";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const currentLanguage =
    languages.find((l) => l.code === i18n.language) || languages[0];
  const FlagIcon = currentLanguage!.Flag;

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 relative group px-3 hover:bg-muted"
        >
          <div className="flex items-center gap-2">
            <div className="w-5 h-4 relative overflow-hidden rounded shadow-sm">
              <FlagIcon className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <span className="font-poppins-medium text-sm hidden md:inline-block">
              {currentLanguage!.name}
            </span>
            <ChevronDown className="h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-background">
        {languages.map((language) => {
          const Flag = language.Flag;
          const isActive = language.code === i18n.language;

          return (
            <DropdownMenuItem
              key={language.code}
              className={`
                flex items-center gap-3 px-3 py-2.5 cursor-pointer
                ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "hover:bg-muted"
                }
                transition-colors duration-200
              `}
              onClick={() => {
                i18n.changeLanguage(language.code);
                setIsOpen(false);
              }}
            >
              <div className="w-5 h-4 relative overflow-hidden rounded shadow-sm">
                <Flag className="absolute inset-0 w-full h-full object-cover" />
              </div>
              <span className="font-poppins-medium text-sm flex-1">
                {language.name}
              </span>
              {isActive && <Check className="h-4 w-4 ml-auto shrink-0" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
